module.exports = __webpack_public_path__ + "static/media/P1010392 - Version 2.672f8219.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/items/new/P1010392 - Version 2.JPG
// module id = 191
// module chunks = 0